"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _addPersonalSubscription = require("./addPersonalSubscription");
Object.keys(_addPersonalSubscription).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _addPersonalSubscription[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _addPersonalSubscription[key];
    }
  });
});
var _addShippingOffer = require("./addShippingOffer");
Object.keys(_addShippingOffer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _addShippingOffer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _addShippingOffer[key];
    }
  });
});
var _addVoucher = require("./addVoucher");
Object.keys(_addVoucher).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _addVoucher[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _addVoucher[key];
    }
  });
});
var _deleteOfferItem = require("./deleteOfferItem");
Object.keys(_deleteOfferItem).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _deleteOfferItem[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _deleteOfferItem[key];
    }
  });
});
var _fetchShoppingContextData = require("./fetchShoppingContextData");
Object.keys(_fetchShoppingContextData).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _fetchShoppingContextData[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _fetchShoppingContextData[key];
    }
  });
});
var _updateOfferItem = require("./updateOfferItem");
Object.keys(_updateOfferItem).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _updateOfferItem[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _updateOfferItem[key];
    }
  });
});
var _replaceSubscription = require("./replaceSubscription");
Object.keys(_replaceSubscription).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _replaceSubscription[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _replaceSubscription[key];
    }
  });
});
